// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section id="customer-loans-edit" class="box">
  <sub-header header="'Edit loan rates'"></sub-header>
  <div class="alert"
       ng-if="\$ctrl.loan.loanType.defaultPastDueToInterestRate || \$ctrl.loan.loanType.defaultPastDueMaturityToInterestRate">
    <div class="message-container">
      At least one rate cannot be edited. As set by the loan product configuration it defaults to the interest rate.
    </div>
  </div>
  <div class="content">
    <form name="\$ctrl.form">
      <form-section>
        <table class="table">
          <thead>
          <th>Name</th>
          <th>Current</th>
          <th>New</th>
          </thead>
          <tbody class="tbody">
          <tr>
            <td>Past due interest rate:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.loan.pastDueInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
            <td>
              <charge
                disable-rate="\$ctrl.loan.loanType.defaultPastDueToInterestRate"
                disable-type="\$ctrl.loan.loanType.defaultPastDueToInterestRate"
                charge="\$ctrl.newPastDueInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
          </tr>
          <tr>
            <td>Past due maturity interest rate:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.loan.pastDueMaturityInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
            <td>
              <charge
                disable-rate="\$ctrl.loan.loanType.defaultPastDueMaturityToInterestRate"
                disable-type="\$ctrl.loan.loanType.defaultPastDueMaturityToInterestRate"
                charge="\$ctrl.newPastDueMaturityInterestCharge"
                types="\$ctrl.pastDueInterestChargeTypes">
              </charge>
            </td>
          </tr>
          <tr>
            <td>Penalty:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.penalty"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
            <td>
              <charge
                disable-rate="\$ctrl.penaltyDefinition.extraOptions.LOAN_BOARD"
                disable-type="\$ctrl.penaltyDefinition.extraOptions.LOAN_BOARD"
                charge="\$ctrl.newPenalty"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
          </tr>
          <tr>
            <td>Penalty maturity:</td>
            <td>
              <charge
                disable-rate="true"
                disable-type="true"
                charge="\$ctrl.loan.penaltyMaturity"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
            <td>
              <charge
                charge="\$ctrl.newPenaltyMaturity"
                types="\$ctrl.penaltyChargeTypes">
              </charge>
            </td>
          </tr>
          </tbody>
        </table>
        <div>
        </div>
        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Cancel</button>
          <button class="btn btn-success" ng-click="\$ctrl.save()"
                  ng-disabled="\$ctrl.form.\$pristine || \$ctrl.form.\$invalid">Save
          </button>
        </div>
      </form-section>
    </form>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-rates.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;